export const SITE = "https://www.wingsoffirefoundation.org";
export const DONATE_URL = "/donation";
export const CONTACT_URL = "/contact-and-connect";

export const NAV = [
  { label: "About Us", href: "/about-us" },
  { label: "Areas of Work", href: "/areas-of-work" },
  { label: "Gallery", href: "/gallery" },
  { label: "Information Hub", href: "/information-hub" },
  { label: "Research", href: "/research-studies" },
  { label: "Contact", href: "/contact-and-connect" },
];

export const AREAS = [
  {
    id: "hotline",
    title: "National Disability Hotline",
    text: "Started in 2000, our helpline services are led by two young people with disabilities with an outreach to 19 states in the country.",
    href: CONTACT_URL,
  },
  {
    id: "eccd",
    title: "Early Childhood Care and Development (ECCD)",
    text: "We work intensively with children with disabilities from a very young age to give them the head start they need.",
    href: "/early-childhood-care-and-development-eccd",
  },
  {
    id: "inclusive-edu",
    title: "Inclusive Education",
    text: "We identify children with disabilities of school-going age and work with their families and schools on their educational opportunities.",
    href: "/inclusive-education",
  },
  {
    id: "life-skills",
    title: "Life Skills for Young Adults with Disabilities",
    text: "We run life skills trainings to help young adults with disabilities live independently and with dignity.",
    href: "/life-skills-for-young-adults-with-disabilities",
  },
  {
    id: "advocacy",
    title: "Research & Policy Advocacy",
    text: "We publish academic studies, research, trainings, and more. We also utilize our expertise to advocate for people with disabilities in the policy space.",
    href: "/research-and-policy-advocacy",
  },
  {
    id: "partnerships",
    title: "Network, Trainings, and Partnership Building",
    text: "We intentionally network and capacity-build outside of the disability advocacy space to make more organizations inclusive.",
    href: "/network-trainings-and-partnership-building",
  },
];

export const STATS = [
  { value: 50, label: "Families", text: "Provided with new ration cards through our assistance" },
  { value: 350, label: "Children", text: "Supported in public schools" },
  { value: 75, label: "Frontline Health Workers", text: "Provided with new ration cards through our assistance" },
  { value: null, label: "Uninterrupted services", text: "for those we serve due to COVID-responsive modifications" },
];

export const MARQUEE = [
  "Ignite Awareness",
  "Inspire Change",
  "Community Based Rehabilitation",
  "Inclusive Education",
  "Dignity for Every Child",
  "Telangana",
];
